exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tutobtn[data-v-2bc07a34]{background-color:#999}.indicator[data-v-2bc07a34]{position:absolute;top:-10px;right:-10px;width:24px;height:24px;background-color:red;border:3px solid #fff;border-radius:50%;display:flex;justify-content:center;align-items:center}.noti_count[data-v-2bc07a34]{font-family:Montserrat,Lucida Sans Unicode,Lucida Grande,Lucida Sans,Arial,sans-serif;color:#f0f8ff;font-weight:700;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bc07a34","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main/Home.vue
// module id = 620
// module chunks = 0